@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

@if(object){
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>{{object.Bezeichnung}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <mat-list>
                @if(object.Strasse){ <mat-list-item><span style="font-weight: bold">{{language.Strasse | translationPipe}}: </span><span>{{object.Strasse}}</span> </mat-list-item>} 
                @if(object.PLZ || object.Ort){ <mat-list-item><span style="font-weight: bold">{{language.PLZ | translationPipe}}/{{language.Ort  | translationPipe}}: </span><span>{{object.PLZ}} {{object.Ort}}</span></mat-list-item>} 
            </mat-list>            
        </mat-card-content>
    </mat-card>
}

<mat-accordion>
    @for(roofArea of roofAreaList; track roofArea.roofArea.Bezeichnung){
    <mat-expansion-panel class="roofPanel">
        <mat-expansion-panel-header>
            <mat-panel-title>{{roofArea.roofArea.Bezeichnung}}</mat-panel-title>
         
        </mat-expansion-panel-header>
            <mat-list>
                <mat-list-item>{{language.Longitude | translationPipe}}: {{roofArea.roofArea.Longitude}}</mat-list-item>
                <mat-list-item>{{language.Latitude | translationPipe}}: {{roofArea.roofArea.Latitude}}</mat-list-item>
                <mat-list-item>{{language.AnzahlSicherungssysteme | translationPipe}}: {{getSicherungsliste(roofArea.roofArea.RoofareaID).length}}</mat-list-item>
                <mat-list-item>{{language.AnzahlSafetypoints | translationPipe}}: {{roofArea.safetyPointList.length}}</mat-list-item>
            </mat-list>   
            @for(sicherungspunkt of getSicherungsliste(roofArea.roofArea.RoofareaID); track sicherungspunkt.SicherungssystemID){

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{sicherungspunkt.Bezeichnung}}</mat-panel-title>
                    </mat-expansion-panel-header>
                        @for(safetyPoint of roofArea.safetyPointList; track safetyPoint.SafetyPointId){
                            @if(safetyPoint.SicherungssystemID == sicherungspunkt.SicherungssystemID){
                                <mat-card appearance="outlined"  (click)="openSafetyPointDialog(safetyPoint, roofArea.roofArea,null)">
                                    <mat-card-content>
                                        <mat-list>
                                            <mat-list-item class="safetyBez" style="display: flex;">{{safetyPoint.Bezeichnung}}                        
                                                @if(safetyPoint.Erledigt){<mat-icon >check</mat-icon>}
                                            </mat-list-item>
                                            <mat-list-item>{{language.Longitude | translationPipe}}: {{safetyPoint.Longitude}}</mat-list-item>
                                            <mat-list-item>{{language.Latitude | translationPipe}}: {{safetyPoint.Latitude}}</mat-list-item>
                                        </mat-list>
                                        <doc-documents [documentList]="getDokumentList(safetyPoint)" [disabled]="true" [maxImageAmount]="getDokumentList(safetyPoint).length"></doc-documents>
                                    </mat-card-content>
                                </mat-card>
                            }
                        }   

                </mat-expansion-panel>                                                        
            }
    </mat-expansion-panel>
    }

    <button mat-fab (click)="openSafetyPointDialog(null,null,object)">
        <mat-icon>add</mat-icon>
    </button>

</mat-accordion>